import Phaser from 'phaser';
import { BootScene } from './scenes/BootScene';
import { TitleScene } from './scenes/TitleScene';
import { GameScene } from './scenes/GameScene';
import { HowToPlayScene } from './scenes/HowToPlayScene';
import { SettingsScene } from './scenes/SettingsScene';
import { LevelCompleteScene } from './scenes/LevelCompleteScene';
import { GameOverScene } from './scenes/GameOverScene';
import { WorldMapScene } from './scenes/WorldMapScene';
import { StoryScene } from './scenes/StoryScene';
import { DailyCalendarScene } from './scenes/DailyCalendarScene';
import { GAME_CONFIG } from './config/game';
import { initBackButton } from './systems/BackButton';

const config: Phaser.Types.Core.GameConfig = {
  type: Phaser.AUTO,
  parent: 'game-container',
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
    width: GAME_CONFIG.width,
    height: GAME_CONFIG.height,
  },
  backgroundColor: '#1a1a2e',
  scene: [BootScene, TitleScene, GameScene, HowToPlayScene, SettingsScene, LevelCompleteScene, GameOverScene, WorldMapScene, StoryScene, DailyCalendarScene],
};

const game = new Phaser.Game(config);
initBackButton(game);

(window as unknown as Record<string, unknown>).game = game;
